import React, { useState } from 'react';

// Material UI
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

// Components
import Dropdown from '../../../../../../components/inputs/dropdown';
import Textfield from '../../../../../../components/inputs/input';
import Upload from '../../../../../../components/inputs/upload';

// Hooks
import useCashRegisterMovementReasons from '../../../../../../hooks/cashRegisterMovementReasons/useCashRegisterMovementReasons';

// Models
import { utils } from "../../../../../../utils/utils";


const Imprest = ({ totals, movement, setMovement, fixedAmount }) => {
    const { cashRegisterMovementReasons } = useCashRegisterMovementReasons({ 
        type: movement.type,
        subType: movement.subType
    });
    const [previewImageUrl, setPreviewImageUrl] = useState('');

    const handleValueChange = (event) =>
        setMovement({
            ...movement,
            [event.target.name]: event.target.value,
        });

    const handleFileUpload = (event) => {
        setPreviewImageUrl(URL.createObjectURL(event.target.files[0]));
        setMovement({ ...movement, files: [event.target.files[0]] })
    }

    const handleFileRemove = () => {
        setPreviewImageUrl('');
        setMovement({ ...movement, files: [] })
    }

    const GetCashTotal = () =>
        totals?.[`Cash${movement.currency}`]?.total || 0;

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Dropdown
                    required
                    fullWidth
                    name='reasonId'
                    label='Seleccionar Motivo'
                    onChange={handleValueChange}
                    getOptionValue={(option) => option?.id}
                    getOptionLabel={(option) => option?.description}
                    values={cashRegisterMovementReasons}
                    value={movement.reasonId}
                />
            </Grid>
            <Grid size={12}>
                <Textfield
                    required
                    fullWidth
                    size='small'
                    name='amount'
                    label='Ingrese Importe'
                    type='number'
                    onChange={handleValueChange}
                    value={movement.amount}
                />
            </Grid>
            <Grid size={12}>
                <Textfield
                    multiline
                    rows={5}
                    fullWidth
                    size='small'
                    name='observation'
                    label='Observación'
                    onChange={handleValueChange}
                    value={movement.observation}
                />
            </Grid>
            <Grid size={12}>
                <Box display='flex' alignItems='center'>
                    <Upload
                        hideLegend
                        id="files-upload"
                        accept=".jpg,.png,.jpeg,.bmp"
                        text="Adjuntar Factura o Ticket"
                        onChange={handleFileUpload}
                        permittedExtensions={["image/png", "image/jpg", "image/jpeg", "image/bmp"]}
                        fileLength={2}
                    />
                    {
                        previewImageUrl &&
                        <div style={{ marginLeft: "10px", height: "63px", display: "flex", alignItems: "center" }}>
                            <HighlightOffIcon onClick={handleFileRemove} />
                            <img src={previewImageUrl} style={{ maxHeight: "50px", maxWidth: "50px", marginLeft: "5px" }} alt="" />
                        </div>
                    }
                </Box>
            </Grid>
            <Grid size={6}>
                <Box display="flex" justifyContent='flex-start'>
                    <Typography color='primary' variant='body1'>
                        Importe en efectivo:
                    </Typography>
                    <Typography variant='body1' style={{ marginLeft: '5px' }}>
                        {utils.formatMoney(GetCashTotal())}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent='flex-start'>
                    <Typography color='primary' variant='body1'>
                        Saldo restante:
                    </Typography>
                    <Typography variant='body1' style={{ marginLeft: '5px' }}>
                        {utils.formatMoney(GetCashTotal() - movement.amount)}
                    </Typography>
                </Box>
            </Grid>
            <Grid size={6}>
                <Box display="flex" justifyContent='flex-end'>
                    <Typography color="primary" variant="body1" gutterBottom>
                        Fondo fijo disponible:&nbsp;
                    </Typography>
                    <Typography variant="body1">
                        <strong>
                            {utils.formatMoney(fixedAmount)}
                        </strong>
                    </Typography>
                </Box>
                <Box display="flex" justifyContent='flex-end'>
                    <Typography color="primary" variant="body1" gutterBottom>
                        Fondo fijo restante:&nbsp;
                    </Typography>
                    <Typography variant="body1">
                        <strong>
                            {utils.formatMoney(fixedAmount - movement.amount)}
                        </strong>
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
}

export default Imprest;